import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

// Module-level cache of short-lived, path-scoped download tokens so the full
// session token never appears in media URLs (shared across components).
const cache = new Map(); // path -> { token, exp }

async function ensure(paths) {
  const now = Date.now();
  const need = paths.filter((p) => p && (!cache.has(p) || cache.get(p).exp < now + 60000));
  if (!need.length) return;
  try {
    const { data } = await api.post("/files/sign", { paths: need });
    Object.entries(data.urls || {}).forEach(([p, tok]) => cache.set(p, { token: tok, exp: now + 14 * 60 * 1000 }));
  } catch {
    /* leave unsigned; URLs resolve to "" until a retry succeeds */
  }
}

// Returns a resolver: signUrl(path) -> full /files URL with a scoped token, or "" until signed.
export function useSignedFiles(paths) {
  const list = (Array.isArray(paths) ? paths : [paths]).filter(Boolean);
  const key = list.slice().sort().join("|");
  const [, bump] = useState(0);
  useEffect(() => {
    if (!list.length) return undefined;
    let active = true;
    ensure(list).then(() => active && bump((n) => n + 1));
    return () => { active = false; };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return (path) => {
    const e = path && cache.get(path);
    return e ? `${API}/files/${path}?token=${e.token}` : "";
  };
}
